<template>
  <Panel :title="organization.name" class="panel-primary">
    <template #header="{ title }">
      <h3 class="panel-title">
        <a
          v-tooltip="expand ? 'Shrink view' : 'Expand view'"
          :aria-label="expand ? 'Shrink view' : 'Expand view'"
          @click.prevent="expand = !expand"
          @keyup.enter="expand = !expand"
        >
          <i v-if="expand" class="glyphicon glyphicon-resize-small" />
          <i v-else class="glyphicon glyphicon-resize-full" />
        </a>
        {{ ' ' }}
        <router-link
          v-if="
            organization.id && organization.system_tags.find((t) => t.startsWith('api_expert:'))
          "
          v-tooltip="'API.expert'"
          :to="{ name: 'organization-home', params: { orgId: organization.id } }"
        >
          <img style="width: 20px; height: 20px" src="/img/api-expert-icon.svg" alt="API.expert" />
          {{ title }}
        </router-link>
        <router-link
          v-else-if="organization.id"
          :to="{ name: 'organization-home', params: { orgId: organization.id } }"
        >
          <i class="fa fa-users" /> {{ title }}
        </router-link>
        <span class="text-normal"> | </span>
        <router-link :to="{ name: 'organization-home', params: { orgId: organization.id } }">
          {{ sortedData.length + ' ' + view }}
        </router-link>
        <span class="text-normal"> | </span>
        <ProjectHeadlines style="display: inline" class="text-normal" :sorted-data="sortedData" />
        <span v-if="!expand" class="text-normal">
          | <a @click.prevent="expand = !expand" @keyup.enter="expand = !expand">More info...</a>
        </span>
        <span class="pull-right">
          <a
            v-tooltip="favorite ? 'Favorite organization' : 'Click to add to favorites'"
            :aria-label="favorite ? 'Favorite organization' : 'Click to add to favorites'"
            @click.stop="toggleFavorite()"
            @keyup.enter="toggleFavorite()"
          >
            <i v-if="favorite" class="glyphicon glyphicon-star" />
            <i v-else class="glyphicon glyphicon-star-empty" />
          </a>
        </span>
        <router-link
          class="badge badge-pill pull-right"
          :to="{ name: 'billing-info', params: { subId: organization.id } }"
          style="margin-right: 12px"
        >
          <SubscriptionPill :system-tags="organization.system_tags" />
        </router-link>
      </h3>
    </template>
    <template v-if="expand" #default>
      <ProjectsDataTable2
        :data="sortedData"
        :loading="false"
        :show-col-picker="true"
        @goto-project="$emit('goto-project', $event)"
        @fav-project="$emit('fav-project', $event)"
        @unfav-project="$emit('unfav-project', $event)"
        @sub-project="$emit('sub-project', $event)"
        @unsub-project="$emit('unsub-project', $event)"
      />
      <ProjectCreate
        v-if="isOrgAdmin"
        :org-id="organization.id"
        @project-created="
          $router.push({ name: 'organization-settings', params: { orgId: organization.id } })
        "
      />
    </template>
  </Panel>
</template>

<script>
import { get } from 'vuex-pathify';
import Panel from '../Panel.vue';
import ProjectHeadlines from './ProjectHeadlines.vue';
import ProjectsDataTable2 from './ProjectsDataTable2.vue';
import ProjectCreate from '../organization/ProjectCreate.vue';
import SubscriptionPill from '../SubscriptionPill.vue';

export default {
  name: 'OrganizationPanel',
  components: {
    Panel,
    ProjectHeadlines,
    ProjectsDataTable2,
    ProjectCreate,
    SubscriptionPill,
  },
  props: {
    initialExpand: {
      type: Boolean,
      required: false,
      default: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    sortedData: {
      type: Array,
      required: true,
    },
    view: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    idx: {
      type: Number,
      required: false,
      default: 0,
    },
    favorite: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      expand: this.initialExpand,
    };
  },
  computed: {
    filter: {
      get() {
        return `${this.value}`; // copy
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isOrgAdmin() {
      const orgRoles = this.roles[this.organization.id] || [];
      return this.isSiteViewer || orgRoles.indexOf('ADMIN') >= 0;
    },
    // subInfo() {
    //   if (this.organization.system_tags.find((t) => t.startsWith('api_expert:'))) {
    //     return 'API.expert';
    //   }
    //   if (this.isOrgAdmin) {
    //     return 'Admin';
    //   }
    //   return 'Organization';
    // },
    roles: get('account2/roles'),
    isSiteViewer: get('account2/isSiteViewer'),
  },
  methods: {
    toggleFavorite() {
      this.$emit(this.favorite ? 'unfav-org' : 'fav-org', this.organization.id);
    },
  },
};
</script>

<style scoped>
.text-normal {
  color: var(--light-main);
}
</style>
